<div class="footer">
  @if (
    step().position > 1 &&
    step().questionnaireType !== questionnaireType.QUESTIONNAIRE_EXAMINATION
  ) {
    <ion-button
      color="medium"
      fill="clear"
      class="previous"
      [disabled]="disablePrevButton()"
      (click)="onPrevClicked($event)"
    >
      Terug
    </ion-button>
  }

  <div class="next">
    <ion-button
      color="success"
      [disabled]="disableNextButton()"
      (click)="onNextClicked($event)"
    >
      {{
        step().thankYouType === ThankYouType.RETURN &&
        step().position === step().totalQuestions
          ? 'Afronden'
          : 'Volgende vraag'
      }}
      <ion-icon slot="end" name="arrow-forward" />
    </ion-button>

    @if (!disableNextButton()) {
      <div class="hotkey ion-hide-md-down">
        Gebruik <span>Shift &#8657; + Enter &#8629;</span>
      </div>
    }
  </div>
</div>
